import Component from '@glimmer/component';

import Sticky from 'rise-ui/components/sticky.gjs';
import DefaultDates from 'rise-ui/components/time-series/selection/line/default-dates.gjs';
import sticky from 'rise-ui/modifiers/sticky.js';

export default class TimeSeriesSelectionDefaultDatesComponent extends Component {
  <template>
    <Sticky @name="default-dates">
      <DefaultDates @layer="sticky" />
    </Sticky>
    <DefaultDates {{sticky activate="default-dates"}} />
  </template>
}
